let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7VXSR")).then(() => parcelRequire('gzICN'));